import routes from '@modules/property-settings/property-settings-routes';

export default {
  routes,
};
